import addDetailsToCustomerAddon from '@/views/profile/plans/addons/addDetailsToCustomerAddon'


const TRAVEL_ADDON_PRODUCT_TYPE = 'travelMobileAddon'
const TRAVEL_ADDON_PLAN_TYPE = 'TravelMobileAddon'
const EXPIRED_STATE = 'EXPIRED'


export function isTravelAddon(addon = {}) {
    return addon.ProductType === TRAVEL_ADDON_PRODUCT_TYPE
        || addon.PlanType === TRAVEL_ADDON_PLAN_TYPE
}


// Travel add-on in a usage-balance response (mapped by map-usage-balance-v2)
export function isTravelBalance(product) {
    return (product || {}).product_type === TRAVEL_ADDON_PRODUCT_TYPE
}


// The balance State is the only source of truth for travel add-on expiry
export function isExpiredTravelBalance(product) {
    return String((product || {}).status || '').toUpperCase() === EXPIRED_STATE
}


export function resolveAddonPriceCents(addon = {}) {
    if (Array.isArray(addon.Prices) && addon.Prices.length) {
        const price = addon.Prices[0] || {}
        return price.DiscountedPrice ?? price.RetailCents ?? price.OrigianlPrice ?? 0
    }

    return isTravelAddon(addon)
        ? (addon.PurchaseRetailPrice ?? 0)
        : (addon.RecurringRetailPrice ?? 0)
}


export default function mapTravelMobileAddon(addon) {
    const cents = resolveAddonPriceCents(addon)

    return addDetailsToCustomerAddon({
        ...addon,
        isCurrentPlan: true,
        isCurrentNextPlan: false,
        name: addon.Name,
        cost: (cents / 100).toFixed(2),
        more_details: addon.Description,
    })
}
